var exports = {
  "qs": "mergeboxLoading__A-z7na",
  "pF": "mergePartialContainer__VUMolp",
  "Qm": "mergeBoxAdjustBorders__A-iNVH",
};

module.exports = exports;
